import styled from "styled-components";

export const Styles = styled.div`
  .ant-form-item-explain-error {
    font-size: 8px !important;
  }
  .ant-picker {
    padding: 0px 11px 0px !important;
  }
`;
